<template>
    <statistics-card-line
        hideChart
        class="mb-base"
        :icon="['fas', 'shopping-cart']"
        icon-right
        :statistic="orderAmount"
        statisticTitle="Openstaande bestellingen" />
</template>

<script>
export default {
	props: {
		orderAmount: {
			required: true
		},
	},
}
</script>
